import React from "react";
import "../Styles/Projects.css";
import { productsList } from "../utils/productsList";
import { Link } from "react-router-dom";

const Products = () => {
  return (
    <div className="projects-page">
      <h1 style={{textAlign:"center",fontFamily:"roboto",padding:"20px"}}>Our Client Projects</h1>
      <div className="projects-grid">
        {productsList.map((product, index) =>(
          <div key={index} className="project-card">
            <img src={product.image} alt={product.title} className="project-image" />
            <div className="project-details">
              <h2>{product.title}</h2>
              <p>{product.description}</p>
              <Link to={product.link} rel="noopener noreferrer" className="project-link">
                View Project
              </Link>
            </div>
          </div>
        ))}
      </div> 
    </div>
  );
};

export default Products;